// https://stackoverflow.com/questions/52188399/typescript-constrain-argument-of-function-to-be-a-key-of-an-object-associated-w
export const sortByLocaleCompare = <T extends Record<K, string>, K extends keyof any>(key: K) => (
  { [key]: a }: T,
  { [key]: b }: T
) => (a?.toLocaleLowerCase() ?? "").localeCompare(b?.toLocaleLowerCase() ?? "");
